import React from "react";

import NavBar from "../../components/navbar/navbar.component";
import Header from "../../components/header/header.component";
import Project from '../../components/project/project.component';
import PROJECTS_DATA from "./projects.data";
import './projects.styles.scss';

class ProjectsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: 'All'
    }

  }

  filterButtonClick(e) {
    this.setState({
      filter: e.target.value
    });
  }

  render() {
    const { filter } = this.state;
    const filteredData = PROJECTS_DATA.projects.filter(function(project) {
      return project.tags.includes(filter);
    });

    return (
      <div>
        <NavBar height={window.innerHeight * 0.4} />
        <Header />

        <div className='section'>
          <p className='title center'>Projects</p>
          <hr />
          <div className="filters">
            <input name='filter' type='button' value='All' className='filterButton' style={{backgroundColor: `${this.state.filter ==='All' ? 'lightblue' : 'white'}`}} onClick={e => this.filterButtonClick(e)} />
            <input name='filter' type='button' value='React.JS' className='filterButton' style={{backgroundColor: `${this.state.filter ==='React.JS' ? 'lightblue' : 'white'}`}} onClick={e => this.filterButtonClick(e)} />
            <input name='filter' type='button' value='Python' className='filterButton' style={{backgroundColor: `${this.state.filter ==='Python' ? 'lightblue' : 'white'}`}} onClick={e => this.filterButtonClick(e)} />
            <input name='filter' type='button' value='SQL' className='filterButton' style={{backgroundColor: `${this.state.filter ==='SQL' ? 'lightblue' : 'white'}`}} onClick={e => this.filterButtonClick(e)} />
          </div>
          <hr className='mid' />
          <div>
            {filteredData.map(({ id, ...projectProps }) => 
              <Project key={id} { ...projectProps } />
            )}
          </div>
        </div>
      </div>
    )
  };
}

export default ProjectsPage;
